import useBootstrapData from './useBootstrapData';

export default function useSurveyUrl() {
  const bootstrapData = useBootstrapData();
  const surveyUrl = bootstrapData?.feedback_survey_url;
  return surveyUrl;
}
